import React from "react";
import { render } from "react-dom";
import _ from "lodash";
import { makeData } from "./utils";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faArrowsAltV, faCaretUp, faCaretDown, faCircle} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  FacebookShareButton,
  TwitterShareButton,
} from 'react-share';


library.add(fab, faArrowsAltV, faCaretUp, faCaretDown, faCircle);

const rawData = makeData();

const requestListData = () => {
  return new Promise((resolve,reject) => {
    const res = {
      rows: rawData,
    };

    setTimeout(() => resolve(res), 500);
  })
}

const requestData = (pageSize, page, sorted, filtered) => {
  return new Promise((resolve, reject) => {
    let filteredData = rawData;

    // You can use the filters in your request, but you are responsible for applying them.
    if (filtered.length) {
      filteredData = filtered.reduce((filteredSoFar, nextFilter) => {
        return filteredSoFar.filter(row => {
          return (row[nextFilter.id] + "").includes((nextFilter.value).toLowerCase());
        });
      }, filteredData);
    }
    // You can also use the sorting in your request, but again, you are responsible for applying it.
    const sortedData = _.orderBy(
      filteredData,
      sorted.map(sort => {
        return row => {

          if (row[sort.id] === null || row[sort.id] === undefined) {
            return -Infinity;
          }

          if(sorted[0].id === "TOTAL_ENROLLMENT_2017") {

            if(row[sort.id] === "") {
              row[sort.id] = 0;
            } else if (typeof row[sort.id] === "string"){
              row[sort.id] = parseFloat((row[sort.id]).replace(",",""));
            }
            
            return typeof row[sort.id] === "string"
              ? row[sort.id].toLowerCase()
              : row[sort.id];

          } else if (sorted[0].id === "COMPLIANCE") {

            return row[sort.id] === "compliant" ? 'D'
              : row[sort.id] === 'significantly compliant' ? 'C'
              : row[sort.id] === 'non-compliant' ? 'B'
              : 'A'
          } else {

            return typeof row[sort.id] === "string"
              ? row[sort.id].toLowerCase()
              : row[sort.id];

          }
        };
      }),
      sorted.map(d => (d.desc ? "desc" : "asc"))
    );

    // You must return an object containing the rows of the current page, and optionally the total pages number.
    const res = {
      rows: sortedData.slice(pageSize * page, pageSize * page + pageSize),
      pages: Math.ceil(filteredData.length / pageSize)
    };

    // Here we'll simulate a server response with 500ms of delay.
    setTimeout(() => resolve(res), 500);
  });
};


function Banner(props) {
  const shareUrl = 'https://demo.project.gothamist.com/campus-assault/';
  const title = 'New York State Campus Assault Tracker';

  return (
    
    <div id="banner">
      <div id="banner-logos">
        <img alt="Gothamist" className="goth-logo" src={require("./images/gothamist_vertical_01.svg")} height="50" width="auto" />
        <img alt="WNYC" className="wnyc-logo" src={require("./images/wnyc-logo.svg")} height="30" width="auto" />
      </div>

      <div id="social-icons">
          <FacebookShareButton
            url={shareUrl}
            quote={title}
            className="share-button">
            <span className="socialIcon" ><FontAwesomeIcon icon={["fab","facebook-f"]} /> </span>
          </FacebookShareButton>
        
        <TwitterShareButton
            url={shareUrl}
            title={title}
            media={require("./images/wnyc-logo.svg")}
            className="share-button">
            <span className="socialIcon" ><FontAwesomeIcon icon={["fab","twitter"]} /> </span>
        </TwitterShareButton>
      </div>
    </div>
  );
}


class SchoolList extends React.Component {

  constructor() {
    super();
    this.state = {
      data: []
    };
    this.fetchData();
  }

  fetchData(state, instance) {
    console.log("aqui")
      requestListData().then(res => {
      this.setState({
        data: res.rows
      });
    });
  }

  render() {

    var schoolData = this.state.data;
    console.log(schoolData)
    return (
      <div id="school-list">
        
        {schoolData.map(function(school, index) {
          var arr = (school.LEGAL_NAME).split(" "), buff = "";
              arr.forEach((word) => {
                if(word.toLowerCase() === "cuny" || word.toLowerCase() === "suny" || word.toLowerCase() === "nyc" || word.toLowerCase() === "asa") {
                  buff += word.toUpperCase() + " ";
                } else{
                  buff += word.charAt(0).toUpperCase() + (word.substr(1)).toLowerCase() + " ";
                }
              })
          var schoolName = buff;

          if(school.INCIDENT_TOTAL_INC === 0 && school.TRAINING_HELD > 0) {

              return (
                <div className="school-list-item" key={ schoolName }>
                  <div className="schoolNameHeader">
                    <span style={{
                        color: school.COMPLIANCE === 'compliant' ? '#57d500' 
                          : school.COMPLIANCE === 'significantly compliant' ? '#ffbf00'
                          : school.COMPLIANCE === 'no info' ? '#36454f'
                          : '#ff2e00',
                        transition: 'all .3s ease'
                      }}>
                        <FontAwesomeIcon icon={"circle"} />
                      </span> 
                    <span className="school-name"> { schoolName } </span>
                    </div>
                  <br />
                  There were no reports of sexual violence at <b>{schoolName}</b> during the  last reporting period. 
                  During that time, <b>{school.TRAINING_STUDENT}</b> trainings were held for students and 
                   <b> {school.TRAINING_STAFF}</b> trainings were held for staff. 
                </div>
              );
            } else if(school.INCIDENT_TOTAL_INC === 0 && school.TRAINING_HELD === 0) {

              return (
                <div className="school-list-item" key={ schoolName }>

                  <div className="schoolNameHeader">
                    <span style={{
                        color: school.COMPLIANCE === 'compliant' ? '#57d500' 
                          : school.COMPLIANCE === 'significantly compliant' ? '#ffbf00'
                          : school.COMPLIANCE === 'no info' ? '#36454f'
                          : '#ff2e00',
                        transition: 'all .3s ease'
                      }}>
                        <FontAwesomeIcon icon={"circle"} />
                      </span> 
                    <span className="school-name"> { schoolName } </span>
                    </div>
                  <br />
                    There were no reports of sexual violence at <b>{buff}</b> during the  last reporting period. 
                    During that time, no trainings were held for students or staff. 
                </div>
              );
            } else if(school.TRAINING_HELD > 0) {

              return (
                <div className="school-list-item" key={ schoolName }>
                  <div className="schoolNameHeader">
                    <span style={{
                        color: school.COMPLIANCE === 'compliant' ? '#57d500' 
                          : school.COMPLIANCE === 'significantly compliant' ? '#ffbf00'
                          : school.COMPLIANCE === 'no info' ? '#36454f'
                          : '#ff2e00',
                        transition: 'all .3s ease'
                      }}>
                        <FontAwesomeIcon icon={"circle"} />
                      </span> 
                    <span className="school-name"> { schoolName } </span>
                  </div>
                  <br />
                    There were <b> {school.INCIDENT_TOTAL_INC} </b> reports of sexual violence at <b>{schoolName}</b> during the  last reporting period. 
                    <ul>
                      <li><b> {school.INCIDENT_SEEK}</b>: number of incidents in which the reporting party sought the institution’s judicial process. </li> 
                      <li><b> {school.CASES_CLOSED_PRIOR}</b>: number of incidents in which the complaint was withdrawn by the reporting party. </li> 
                      <li><b> {school.CASES_RESPONSIBLE}</b>: number of incidents in which the respondent was found responsible. </li> 
                    </ul>
                    During the last reporting period, there were <b>{school.TRAINING_STUDENT}</b> trainings held for students and 
                    <b> {school.TRAINING_STAFF}</b> trainings held for staff.  
                </div>
              );
            } else {
              return (
                <div className="school-list-item" key={ schoolName }>

                  <div className="schoolNameHeader">
                    <span style={{
                        color: school.COMPLIANCE === 'compliant' ? '#57d500' 
                          : school.COMPLIANCE === 'significantly compliant' ? '#ffbf00'
                          : school.COMPLIANCE === 'no info' ? '#36454f'
                          : '#ff2e00',
                        transition: 'all .3s ease'
                      }}>
                        <FontAwesomeIcon icon={"circle"} />
                      </span> 
                    <span className="school-name"> { schoolName } </span>
                    </div>
                  <br />
                  There were <b> {school.INCIDENT_TOTAL_INC} </b> reports of sexual violence at <b>{schoolName}</b> during the  last reporting period. 
                  <ul>
                    <li><b> {school.INCIDENT_SEEK}</b>: number of incidents in which the reporting party sought the institution’s judicial process. </li> 
                    <li><b> {school.CASES_CLOSED_PRIOR}</b>: number of incidents in which the complaint was withdrawn by the reporting party. </li> 
                    <li><b> {school.CASES_RESPONSIBLE}</b>: number of incidents in which the respondent was found responsible. </li> 
                  </ul>
                  
                  During the last reporting period, no trainings were held for students or staff.


                </div>
              )
            }
          
        })}
        
      </div>
    )
  }
}

// return <li key={ school } >{ school }</li>; 


function Square(props) {
  return (
    
    <div className="square">
      <div className="legend">
        <span className="legendItem">compliant  <FontAwesomeIcon className="legendCircle green" icon={"circle"} /> </span>
        <span className="legendItem">significantly compliant  <FontAwesomeIcon className="legendCircle yellow" icon={"circle"} /> </span>
        <span className="legendItem">non-compliant  <FontAwesomeIcon className="legendCircle red" icon={"circle"} /> </span>
        <span className="legendItem">data unavailable  <FontAwesomeIcon className="legendCircle grey" icon={"circle"} /> </span>
      </div>
    </div>
  );
}

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      pages: null,
      loading: true,
    };
    
    this.fetchData = this.fetchData.bind(this);
  }
  // updateDimensions() {
  //   const reelContainerWidth = window.innerWidth;
  //   this.setState({ reelContainerWidth: reelContainerWidth });
  // }
  // componentDidMount() {
  //   this.updateDimensions();
  //   this.setState({
  //       reelContainerWidth:window.innerWidth
  //   });
  //   window.addEventListener("resize", this.updateDimensions);
  // }
  // componentWillUnmount() {
  //   window.removeEventListener("resize", this.updateDimensions);
  // }
  fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // console.log("Sorted: ", state.sorted);
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false,
        sorted: state.sorted
      });
    });
  }
  handleSearchChange(state,instance) {
    console.log("sup");
  }
  render() {
    const { data, pages, loading } = this.state;
    if(window.innerWidth < 100) {
      return (
        <div>
          <Banner />
          <Square />
          <SchoolList 
            data={this.state.data}
            onFetchData={this.fetchData}
          />
        </div>
      )
    } else {

      return (
        <div>
          <Banner />
          <Square />
          <ReactTable

            columns={[
              {
                Header: () => { 
                  var icon = "";
                  if(this.state.sorted && (this.state.sorted).length > 0) {
                    var sortedColumn = (this.state.sorted)[0];
                    if(sortedColumn.id === "LEGAL_NAME") {
                        icon = sortedColumn.desc === true ? "caret-down" : "caret-up";
                    } else {
                      icon = "arrows-alt-v";
                    }
                  } else {
                    icon = "caret-down";
                  }
                  return (
                    <span className="column-icon">
                      <FontAwesomeIcon icon={icon} /> SCHOOL
                    </span> 
                  )
                },
                accessor: "LEGAL_NAME",
                minWidth: 200,
                style: {"fontFamily":"OpenSans"},
                Cell: (props) => {
                  var arr = (props.value).split(" "), buff = "";
                  arr.forEach((word) => {
                    if(word.toLowerCase() === "cuny" || word.toLowerCase() === "suny" || word.toLowerCase() === "nyc" || word.toLowerCase() === "asa") {
                      buff += word.toUpperCase() + " ";
                    } else{
                      buff += word.charAt(0).toUpperCase() + (word.substr(1)).toLowerCase() + " ";
                    }
                  })
                  return buff;
                }
              },
              {
                Header: () => { 
                  var icon = "";
                  if(this.state.sorted && (this.state.sorted).length > 0) {
                    var sortedColumn = (this.state.sorted)[0];
                    if(sortedColumn.id === "TOTAL_ENROLLMENT_2017") {
                        icon = sortedColumn.desc === true ? "caret-down" : "caret-up";
                    } else {
                      icon = "arrows-alt-v";
                    }
                  } else {
                    icon = "arrows-alt-v";
                  }
                  return (
                    <span className="column-icon">
                      <FontAwesomeIcon icon={icon} /> ENROLLMENT
                    </span> 
                  )
                },
                accessor: "TOTAL_ENROLLMENT_2017",
                style: {"fontFamily":"OpenSans"},
                filterable: false,
                Cell: (props) => {
                  return typeof props.value === "string" ? props.value 
                  : props.value === 0 ? "" 
                  : (props.value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
              },
              {
                Header: () => { 
                  var icon = "";
                  if(this.state.sorted && (this.state.sorted).length > 0) {
                    var sortedColumn = (this.state.sorted)[0];
                    if(sortedColumn.id === "TRAINING_HELD") {
                        icon = sortedColumn.desc === true ? "caret-down" : "caret-up";
                    } else {
                      icon = "arrows-alt-v";
                    }
                  } else {
                    icon = "arrows-alt-v";
                  }
                  return (
                    <span className="column-icon">
                      <FontAwesomeIcon icon={icon} /> TRAINING HELD
                    </span> 
                  )
                },
                accessor: "TRAINING_HELD",
                filterable: false,
                style: {"fontFamily":"OpenSans"},
                Cell: props => <span className='training-held'>{props.value === 0 || props.value === "" ? "NO" : "YES"}</span>              
              },
              {
                Header: () => { 
                  var icon = "";
                  if(this.state.sorted && (this.state.sorted).length > 0) {
                    var sortedColumn = (this.state.sorted)[0];
                    if(sortedColumn.id === "INCIDENT_TOTAL_INC") {
                        icon = sortedColumn.desc === true ? "caret-down" : "caret-up";
                    } else {
                      icon = "arrows-alt-v";
                    }
                  } else {
                    icon = "arrows-alt-v";
                  }
                  return (
                    <span className="column-icon">
                      <FontAwesomeIcon icon={icon} /> INCIDENT TOTAL
                    </span> 
                  )
                },
                accessor: "INCIDENT_TOTAL_INC",
                style: {"fontFamily":"OpenSans"},
                filterable: false
              },
              {
                Header: () => { 
                  var icon = "";
                  if(this.state.sorted && (this.state.sorted).length > 0) {
                    var sortedColumn = (this.state.sorted)[0];
                    if(sortedColumn.id === "COMPLIANCE") {
                        icon = sortedColumn.desc === true ? "caret-down" : "caret-up";
                    } else {
                      icon = "arrows-alt-v";
                    }
                  } else {
                    icon = "arrows-alt-v";
                  }
                  return (
                    <span className="column-icon">
                      <FontAwesomeIcon icon={icon} /> COMPLIANCE
                    </span> 
                  )
                },
                accessor: "COMPLIANCE",
                style: {"fontFamily":"OpenSans"},
                filterable: false,
                Cell: row => (
                  <span>
                    <span className="data-circ" style={{
                      color: row.value === 'compliant' ? '#57d500' 
                        : row.value === 'significantly compliant' ? '#ffbf00'
                        : row.value === 'no info' ? '#36454f'
                        : '#ff2e00',
                      transition: 'all .3s ease'
                    }}>
                      <FontAwesomeIcon icon={"circle"} />
                    </span> 
                  </span>
                )
              }
            ]}
            manual // Forces table not to paginate or sort automatically, so we can handle it server-side
            data={data}
            pages={pages} // Display the total number of pages
            loading={loading} // Display the loading overlay when we need it
            onFetchData={this.fetchData} // Request new data when things change
            filterable
            defaultPageSize={25}
            className="-striped -highlight"
            SubComponent={row => {
              var arr = (row.original.LEGAL_NAME).split(" "), buff = "";
                  arr.forEach((word) => {
                    buff += word.charAt(0).toUpperCase() + (word.substr(1)).toLowerCase() + " ";
                  });
              console.log(row.original.COMPLIANCE);
              if(row.original.INCIDENT_TOTAL_INC === 0 && row.original.TRAINING_HELD > 0) {
                return (
                  <div className="expanded-info-none">
                    <br />
                    There were no reports of sexual violence at <b>{buff}</b> during the  last reporting period. 
                    During that time, <b>{row.original.TRAINING_STUDENT}</b> trainings were held for students and 
                     <b> {row.original.TRAINING_STAFF}</b> trainings were held for staff. 
                  </div>
                );
              } else if (row.original.INCIDENT_TOTAL_INC === 0 && row.original.TRAINING_HELD === 0) {
                return (
                  <div className="expanded-info-none">
                    <br />
                      There were no reports of sexual violence at <b>{buff}</b> during the  last reporting period. 
                      During that time, no trainings were held for students or staff. 
                  </div>
                );
              } else if (row.original.TRAINING_HELD > 0) {
                return (
                  <div className="expanded-info">
                    <br />
                      There were <b> {row.original.INCIDENT_TOTAL_INC} </b> reports of sexual violence at <b>{buff}</b> during the  last reporting period. 
                      <ul>
                        <li><b> {row.original.INCIDENT_SEEK}</b>: number of incidents in which the reporting party sought the institution’s judicial process. </li> 
                        <li><b> {row.original.CASES_CLOSED_PRIOR}</b>: number of incidents in which the complaint was withdrawn by the reporting party. </li> 
                        <li><b> {row.original.CASES_RESPONSIBLE}</b>: number of incidents in which the respondent was found responsible. </li> 
                      </ul>
                      During the last reporting period, there were <b>{row.original.TRAINING_STUDENT}</b> trainings held for students and 
                      <b> {row.original.TRAINING_STAFF}</b> trainings held for staff. 
                  </div>
                );
              } else {
                return (
                  <div className="expanded-info">
                    <br />
                      There were <b> {row.original.INCIDENT_TOTAL_INC} </b> reports of sexual violence at <b>{buff}</b> during the  last reporting period. 
                      <ul>
                        <li><b> {row.original.INCIDENT_SEEK}</b>: number of incidents in which the reporting party sought the institution’s judicial process. </li> 
                        <li><b> {row.original.CASES_CLOSED_PRIOR}</b>: number of incidents in which the complaint was withdrawn by the reporting party. </li> 
                        <li><b> {row.original.CASES_RESPONSIBLE}</b>: number of incidents in which the respondent was found responsible. </li> 
                      </ul>
                      
                      During the last reporting period, no trainings were held for students or staff.
                  </div>
                );
              }
            }}
          />
          <br />
        </div>
      );
    }
  }
}

render(<App />, document.getElementById("root"));


// getTdProps={(state, rowInfo, column, instance) => {
//   return {
//     onClick: (e, handleOriginal) => {
//       console.log("A Td Element was clicked!");
//       console.log("it produced this event:", e);
//       console.log("It was in this column:", column);
//       console.log("It was in this row:", rowInfo);
//       console.log("It was in this table instance:", instance);

//       if (handleOriginal) {
//         handleOriginal();
//       }
//     }
//   };
// }}



// WEBPACK FOOTER //
// ./src/index.js